// UrlOrderLoader.js
import { connect } from 'react-redux';
import loadUrlOrderProcessing from '../action/loadUrlOrderProcessing.js';
import UrlLoader from '../component/UrlLoader.jsx';

const mapDispatchToProps = dispatch => {
  return {
    urlHandler: ({ url }) => dispatch(loadUrlOrderProcessing({ url })),
  };
};

export default connect(null, mapDispatchToProps)(UrlLoader);
